module.exports = __webpack_public_path__ + "img/align-3--active.f7535f3d.svg";